var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgAutopassapp = function SvgAutopassapp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u5716\\u5C64_2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28.35 28.35",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#fff800;}.cls-3{fill:#ffbc00;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Brand"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    width: 28.35,
    height: 28.35,
    rx: 7.93,
    ry: 7.93
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M4.96,19.93c-.16,0-.31-.06-.43-.18-.11-.11-.17-.26-.17-.42s.06-.31,.17-.42c.22-.22,.62-.22,.85,0,.11,.11,.18,.27,.18,.43s-.07,.31-.18,.42c-.11,.11-.27,.18-.42,.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.8,10.08c-.16,0-.31-.06-.43-.17-.11-.11-.17-.27-.17-.43s.06-.31,.17-.42c.22-.22,.63-.22,.85,0,.11,.11,.18,.27,.18,.42s-.07,.31-.18,.43c-.11,.11-.27,.17-.42,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M18.37,18.73H6.59c-.33,0-.6,.27-.6,.6s.27,.6,.6,.6h11.78c.33,0,.6-.27,.6-.6s-.27-.6-.6-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.8,17.07H3.13c-.33,0-.6-.27-.6-.6s.27-.6,.6-.6h3.66c.33,0,.6,.27,.6,.6s-.27,.6-.6,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M6.67,14.77h-1.71c-.33,0-.6-.27-.6-.6s.27-.6,.6-.6h1.71c.33,0,.6,.27,.6,.6s-.27,.6-.6,.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M7.59,12.42h-3.47c-.33,0-.6-.27-.6-.6s.27-.6,.6-.6h3.47c.33,0,.6,.27,.6,.6s-.27,.6-.6,.6Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.07,9.02c-.89,0-1.76,.25-2.55,.7-.9,.51-2.02,.53-2.88-.04-.63-.42-1.4-.66-2.27-.66-2.68,0-5.24,2.31-5.7,5.16-.47,2.85,1.33,5.16,4.01,5.16,.89,0,1.76-.25,2.55-.7,.9-.51,2.02-.53,2.88,.04,.63,.42,1.4,.66,2.27,.66,2.68,0,5.24-2.31,5.7-5.16,.47-2.85-1.33-5.16-4.01-5.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.37,19.93c-.95,0-1.85-.26-2.6-.76-.64-.42-1.53-.42-2.26-.02-.9,.51-1.89,.77-2.85,.77-1.41,0-2.66-.56-3.53-1.59-.94-1.11-1.33-2.66-1.06-4.26,.51-3.12,3.34-5.66,6.3-5.66,.95,0,1.85,.26,2.6,.76,.64,.42,1.53,.42,2.26,.02,.9-.51,1.89-.77,2.85-.77,1.41,0,2.66,.56,3.53,1.59,.94,1.11,1.33,2.66,1.06,4.26-.51,3.12-3.34,5.66-6.3,5.66Zm-3.7-2.28c.64,0,1.25,.18,1.77,.52,.55,.37,1.22,.56,1.93,.56,2.4,0,4.69-2.09,5.11-4.65,.21-1.25-.08-2.45-.79-3.29-.64-.75-1.57-1.17-2.62-1.17-.76,0-1.54,.21-2.26,.62-1.11,.62-2.5,.6-3.5-.06-.55-.37-1.22-.56-1.93-.56-2.4,0-4.69,2.09-5.11,4.65-.21,1.25,.08,2.45,.79,3.29,.64,.75,1.57,1.17,2.62,1.17,.76,0,1.54-.21,2.26-.62,.54-.3,1.14-.46,1.74-.46Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.4,14.89c-.22,0-.42-.08-.57-.24l-.56-.56c-.18-.18-.18-.46,0-.64,.18-.18,.46-.18,.64,0l.5,.5,.8-.8c.18-.18,.46-.18,.64,0,.18,.18,.18,.46,0,.64l-.86,.86c-.15,.15-.36,.24-.57,.24Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.35,12.01c0,.33-.27,.6-.6,.6s-.6-.27-.6-.6,.27-.6,.6-.6,.6,.27,.6,.6Z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 21.65,
    cy: 12.01,
    r: 0.6
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgAutopassapp);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "autopassapp.717eeb5d390361aba7494534765f0136.svg";